import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// FIX: Handle Google OAuth Redirect for HashRouter
// Google redirects to /google-callback (Standard Path)
// HashRouter expects /#/google-callback (Hash Path)
// We detect this mismatch and fix the URL before the app loads.
const currentPath = window.location.pathname;
if (currentPath === '/google-callback' || currentPath === '/google-callback/') {
    const search = window.location.search;
    // Redirect to the hash version, preserving the OAuth code/state params
    window.location.replace(`/#/google-callback${search}`);
} else {
    // Normal App Initialization
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error("Could not find root element to mount to");
    }

    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
}